var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"geoloc",class:{ 'has-error': !_vm.client.zipcode }},[_c('geoloc',{attrs:{"geoloc":_vm.geoloc,"address":_vm.formatAddress(_vm.client),"displayAddress":true,"placeholder":"Adresse du client","disabled":!_vm.hasPermission(_vm.$store.state.user, 'CLIENTS_WRITE')},on:{"placeChanged":_vm.handleAddress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }